var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F34336;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FFC007;}\r\n\t.st3{fill:#FFEA3B;}\r\n\t.st4{fill:#646565;}\r\n\t.st5{fill:#4CAE50;}\r\n\t.st6{fill:#CBCBCB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.19,
    y: 48.79,
    className: "st3",
    width: 405.61,
    height: 414.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228,352.19v55.85c1.91,0.31,3.83,0.46,5.75,0.46c1.81,0,3.7-0.15,5.67-0.46v-55.85 c-1.97-0.31-3.88-0.46-5.75-0.46S229.91,351.88,228,352.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M250.29,352.19v55.85c1.91,0.31,3.83,0.46,5.75,0.46c1.81,0,3.7-0.15,5.67-0.46v-55.85 c-1.97-0.31-3.88-0.46-5.75-0.46C254.1,351.73,252.21,351.88,250.29,352.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.58,352.19v55.85c1.91,0.31,3.83,0.46,5.75,0.46c1.81,0,3.7-0.15,5.67-0.46v-55.85 c-1.97-0.31-3.88-0.46-5.75-0.46C276.39,351.73,274.5,351.88,272.58,352.19z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st4",
    d: "M214.74,178.43l-30.31,60.35l0.17,0.1c6.08,3.44,11.4,2.65,14.25-2.1 c3.69-6.2,7.43-10.34,13.65-10.34c6.39,0,9.31,5.32,11.42,9.19l3.77,6.59c2.64,4.59,4.08,6.88,7.15,6.88 c2.31,0,4.98-2.14,5.46-5.74l1.64-12.35c0.93-6.99,5.97-11.86,12.25-11.86c6.09,0,8.64,4.77,10.7,8.63 c0.38,0.69,0.75,1.42,1.15,2.08c1.41,2.45,5.18,5.84,10.13,7.52c3.42,1.17,5.62,2.84,7.39,4.17c2.01,1.55,3.34,2.56,6.04,2.7 c3.32,0.17,6.84-1.55,9.03-15.88c0.62-4.04,2.87-7.46,6.01-9.14c1.61-0.85,4.03-1.55,7.15-0.89l-19.47-39.8 c-5.13,9.13-20.07,15.4-38.75,15.4C234.82,193.94,219.8,187.63,214.74,178.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st4",
    d: "M343.62,283.42l-27.79-56.77l-3.43-1.62c-1.96-0.9-3.59-1.04-4.88-0.32 c-1.4,0.74-2.47,2.51-2.81,4.6c-1,6.54-3.38,21.76-15.46,21.11c-4.59-0.26-7.17-2.22-9.45-3.93c-1.63-1.24-3.17-2.4-5.65-3.24 c-6.92-2.38-11.57-7.04-13.47-10.29c-0.43-0.75-0.85-1.52-1.24-2.27c-2.09-3.9-3.1-5.38-5.25-5.38c-3.63,0-5.7,3.28-6.12,6.5 l-1.63,12.34c-0.85,6.34-5.82,11.1-11.59,11.1c-6.76,0-9.75-5.19-12.37-9.74l-3.96-6.95c-2.04-3.71-3.46-5.97-6.01-5.97 c-2.58,0-4.68,1.15-8.34,7.3c-4.59,7.74-13.42,9.45-22.49,4.36l-31.04,61.76c0,6.76,15.38,4.35,22.66,2.82l21.21-48.32l5.65,2.5 l-20.67,47.06c7.38,6.04,29.81,22.12,44.51,7.79l1.31-24.79l6.18,0.32l-1.23,23.21c6.8,3.11,22.15,9.36,36.4,9.36 c32.04,0,47.48-12.76,52.79-18.5l-13.71-37.08l5.78-2.14l15.07,40.72c11.84,9,13.19-2.47,34.8,3.95L343.62,283.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st4",
    d: "M288.03,171.48c0-0.9-0.2-1.81-0.52-2.69c0,0,0-0.05-0.01-0.05v-0.01 c-2.8-7.67-16.91-13.53-33.94-13.53c-17.04,0-31.15,5.85-33.94,13.53v0.01c0,0-0.01,0.01-0.01,0.05c-0.16,0.41-0.29,0.84-0.36,1.29 c-0.09,0.46-0.16,0.94-0.16,1.4c0,9.01,15.43,16.29,34.48,16.29C272.6,187.77,288.03,180.48,288.03,171.48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelThree);
export default __webpack_public_path__ + "static/media/LevelThree.c12501edcc4510efc904a86bb1946048.svg";
export { ForwardRef as ReactComponent };